/* eslint-disable react-hooks/exhaustive-deps */
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import React, { useState, useMemo } from 'react';
import SubjectsMap from '../SubjectsMap';
import Widget from '../../../../../../Analysis/widget';
import { mapTypesButtons } from './config';
import ComponentWithFocus from '../../../../../../Analysis/components/component-with-focus';
import { useCallback } from 'react';
import { AuthenticationService, DashboardService } from '../../../../../../../services';
import { useEffect } from 'react';

const module = 'tazama';

const MapWidget = ({
  selectedParters = [],
  loading: partnersLoading = false,
}) => {
  const { t } = useTranslation();
  const [activeMapType, setActiveMapType] = useState(mapTypesButtons[0].type);
  const [closed, setClosed] = useState(false);
  const { user } = useSelector((state) => state.authentication);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    if (partnersLoading) {
      return;
    }

    setLoading(true);

    try {
      const { data } = await DashboardService.getMap(selectedParters);
      const { data: options } = await AuthenticationService.getFormOptions({
        references: ['typeOptions', 'categoryOptions'],
      });
      setData({ ...data, options });
    } catch (err) {
      console.log(err);
    }

    setLoading(false);
  }, [selectedParters, partnersLoading]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const allData = useMemo(() => {
    if (activeMapType === 'location') {
      return (data?.locations || []).map((d) => ({
        ...d,
        category: ['mineSite', 'village'].includes(d?.category) ? d.category : 'other',
        marker: {
          lat: d.gps.latitude,
          lng: d.gps.longitude,
        },
      }));
    }

    const locations = {};

    (data?.events || []).forEach((d) => {
      if (d.severity) {
        const location = Array.isArray(d.location) ? d.location[0] : d.location;
        if (location) {
          if (!locations[location.id]) {
            locations[location.id] = {
              ...location,
              data: [d],
            };
          } else {
            locations[location.id].data.push(d);
          }
        }
      }
    });

    return Object.keys(locations).map((key) => {
      const location = locations[key];

      return {
        ...location,
        datastakeId: location?.parent?.datastakeId,
        marker: {
          lat: location?.gps?.latitude,
          lng: location?.gps?.longitude,
        }
      };
    })
  }, [activeMapType, data]);

  const language = useMemo(() => user?.language, [user]);

  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => { },
  }), [closed]);

  const tabsConfig = {
    tabs: mapTypesButtons.map((v) => ({ value: v.type, label: t(v.label) })),
    value: activeMapType,
    onChange: (val) => {
      if (loading || partnersLoading) {
        return;
      }

      setActiveMapType(val);
    },
  }

  return (
    <Widget
      title={t('Monitoring Map')}
      loading={loading || partnersLoading}
      tabsConfig={tabsConfig}
      className="v2-widget no-px no-pb-body"
    >
      <ComponentWithFocus actions={actions}>
        <SubjectsMap
          t={t}
          data={allData}
          user={user}
          options={data.options}
          selectedParters={selectedParters}
          module={module}
          onFiltersChange={(val) => {
            if (val?.filters?.subject) {
              setActiveMapType(val?.filters?.subject);
            }
          }}
          initialType={mapTypesButtons[0].type}
          language={language}
          activeMapType={activeMapType}
        />
      </ComponentWithFocus>
    </Widget>
  );
}

export default MapWidget;
